<template>
    <div v-show="!modoConferencia">
        <div v-if="isLoading" class="loading-overlay"><p>Carregando...</p></div>
        <div v-if="msgAlerta" class="info-alert row-space">{{ msgAlerta }}</div>

        <div class="form-edit-page row row-space">
            <div class="form-item">
                <EstabelecimentoSelect :ck-add-todos="true" v-model:idSelecionado="estabelecimentoSelecionado" />
            </div>
            
            <button type="button" class="buttom-icon--search" @click="lerDados" />
            <button type="button" class="buttom-icon--close" @click="closeForm" />
        </div>


        <div v-if="lsDados.length>0" class="table-wrapper">
            <table>
                <thead>
                    <tr>
                        <th>Referência</th>
                        <th>Protocolo Ref</th>
                        <th>Protocolo RAC</th>
                        <th>Data/Hora</th>
                        <th>Estabelecimento</th>
                    </tr>
                </thead>
                <tbody>
                    <tr v-for="(pla08, index) in lsDados" :key="pla08.id" @click="onClickItem(pla08)"
                    :class="{'even-row': index % 2 === 0, 'odd-row': index % 2 !== 0, 'clickabe-row': true}">
                        <td class="col-width-char15 center">{{ pla08.ref_titulo }}</td>
                        <td class="col-width-char15 center">{{ pla08.ref_protocolo }}</td>
                        <td class="col-width-char20 center">{{ pla08.protocolo }}</td>
                        <td class="col-width-char20 center">{{ Funcoes.formatDateTimeFromJson(pla08.dhprotocolo) }}</td>
                        <td>{{ pla08.nmestabelecimento }}</td>
                    </tr>
                </tbody>
            </table>
        </div>

        <div v-if="showPagination" class="pagination">
            <button :disabled="currentPage === 1" class="buttom-pagination--first" @click="currentPage=1; updatePaginatedData();" />
            <button :disabled="currentPage === 1" class="buttom-pagination--prior" @click="currentPage--; updatePaginatedData();" />
            <div class="field-label field-label-center">{{ currentPage }} de {{ Math.ceil(lsDadosMain.length / itemsPerPage) }}</div>
            <button :disabled="currentPage === Math.ceil(lsDadosMain.length / itemsPerPage)" class="buttom-pagination--next" @click="currentPage++; updatePaginatedData();" />
            <button :disabled="currentPage === Math.ceil(lsDadosMain.length / itemsPerPage)" class="buttom-pagination--last" @click="currentPage = Math.ceil(lsDadosMain.length / itemsPerPage); updatePaginatedData();" />
        </div>
    </div>


    <template v-if="modoConferencia">
        <RacDeferimentoEditPage :idEdicao="idEdicao" @close="modoConferencia = false" @save="lerDados" />
    </template>
</template>

<script setup>
import { onMounted, ref } from 'vue';
import { Funcoes } from '@/funcoes/funcoes';
import { genericPost } from '@/funcoes/api';
import { globalStore } from '@/globals';
import EstabelecimentoSelect from '@/components/selects/EstabelecimentoSelect.vue';
import RacDeferimentoEditPage from '../outros/RacDeferimentoEditPage.vue';

const emit = defineEmits(['close']);
const estabelecimentoSelecionado = ref(null);
const idEdicao = ref(null);
const isLoading = ref(false);
const lsDados = ref([]);
const modoConferencia = ref(false);
const msgAlerta = ref(null);

const currentPage = ref(1);
const itemsPerPage = ref(globalStore.itensPorPagina);
const lsDadosMain = ref([]);
const showPagination = ref(false);

const closeForm = () => {emit('close');}

const lerDados = async() => {
    try {
        msgAlerta.value = null;
        isLoading.value = true;
        const dados = {
            idep: globalStore.idep,
            idsim: globalStore.idsim,
            idestabelecimento: estabelecimentoSelecionado.value,
            intparam1: 5};
        const req = await genericPost('/dados/rac', dados);
        lsDadosMain.value = req;
        currentPage.value=1;
        showPagination.value = (lsDadosMain.value.length > itemsPerPage.value);
        updatePaginatedData();
    } catch (error){msgAlerta.value = `ATENÇÃO: ${error.response?.data || error.message}`;
    } finally {isLoading.value = false;}
}

function onClickItem(obj){
    idEdicao.value = obj.id;
    modoConferencia.value = true;
}

const updatePaginatedData = () => {
    const startIndex = (currentPage.value - 1) * itemsPerPage.value;
    const endIndex = (startIndex + itemsPerPage.value);
    lsDados.value = lsDadosMain.value.slice(startIndex, endIndex);
}

onMounted(lerDados);
</script>